/**
 * Shows the sticky bar only once the buy box has been scrolled past.
 *
 * Two CTAs on screen at once is the thing to avoid, so the bar stays hidden
 * while any part of the add-to-cart button is visible — including at the top
 * of the page, before it has been reached. It appears only when the button has
 * passed above the top of the viewport, and hides again on the way back up.
 *
 * Only used when the bar is a link back to the buy box. In that mode it is a
 * plain <div>, not Horizon's <sticky-add-to-cart>: that component requires an
 * addToCartButton ref, and supplying a stub one duplicated the ref that
 * ProductFormComponent needs, which silently broke add to cart.
 */
(() => {
  const bar = document.querySelector('.sticky-add-to-cart > .sticky-add-to-cart__bar');
  const target = document.querySelector('button.add-to-cart-button:not(.sticky-add-to-cart__button)');
  if (!bar || !target) return;

  const update = (entry) => {
    // Scrolled past: the button's bottom edge is above the viewport. Anything
    // else — visible, or still below the fold — keeps the bar down.
    const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
    bar.dataset.stuck = scrolledPast ? 'true' : 'false';
  };

  const observer = new IntersectionObserver(([entry]) => update(entry), { threshold: 0 });
  observer.observe(target);
})();
